import { useEffect, useState } from 'react';
import { ArrowRight, Filter, Search } from 'react-feather';
import styles from './devicealert.module.css';
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import { Link } from "react-router-dom";
import FilterAutocomplete from "../../../components/FilterAutocomplete";

const STATUS_OPTIONS = [
    { value: "all", label: "All" },
    { value: 0, label: "Active" },
    { value: 1, label: "Archived" },
];

const FilterComponent = ({ filterData, setFilterData }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [allProperties, setAllProperties] = useState([]);
    const [filterOpen, setFilterOpen] = useState(false);
    const OpenFilterDrawer = () => {
        setFilterOpen(true)
    }
    const CloseFilterDrawer = () => {
        setFilterOpen(false)
    }

    const allApartments = allProperties.find(item => item?.value === filterData?.property)?.apartments || [];

    useEffect(() => {
        const fetchAllProperties = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
            await axios.get(process.env.REACT_APP_DEVICE_API_URL + "v1/properties", {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                setAllProperties(response.data?.data || []);
            }).catch((error) => {
                if (typeof error.response !== "undefined")
                    toast.error(error.response.data.message);
            });
        };
        fetchAllProperties();
    }, [getAccessTokenSilently]);

    return (
        <div className={`${styles.SearchFilterSec}`}>
            <div className={`${styles.SearchCon}`}>
                <div className={`${styles.SearchConSec}`}>
                    <Search />
                    <input type="text" placeholder="Search" onChange={(e) => setFilterData(prev => { return { ...prev, searchKey: e.target.value }; })} />
                </div>
            </div>
            <div className={`${styles.FilterSec}`}>
                <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
                    <p className={`${styles.FilterTitle}`}>
                        Filters
                        <span onClick={CloseFilterDrawer}><ArrowRight /></span>
                    </p>
                    <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                        <FilterAutocomplete
                            label="Select Property"
                            options={allProperties}
                            value={filterData?.property}
                            onChange={(value) => setFilterData(prev => ({ ...prev, property: value, apartment: "" }))}
                        />
                    </div>
                    <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                        <FilterAutocomplete
                            label="Select Apartment"
                            options={allApartments}
                            value={filterData?.apartment}
                            noOptionsText={filterData?.property === "" ? "Select Property First" : "No options"}
                            onChange={(value) => setFilterData(prev => ({ ...prev, apartment: value }))}
                        />
                    </div>
                    <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width200} CusSelectFilter Filter`}>
                        <FilterAutocomplete
                            label="Select Status"
                            options={STATUS_OPTIONS}
                            value={filterData?.is_archived}
                            disableClearable
                            onChange={(value) => setFilterData(prev => ({ ...prev, is_archived: value }))}
                        />
                    </div>
                </div>
                <Link className={`${styles.FilterBu}`} onClick={OpenFilterDrawer}><Filter /></Link>
            </div>
        </div>
    )

}


export default FilterComponent;
